var parse = function parse(timeStr) {
  var a = timeStr.split(/[^0-9]/).map(function (item) {
    return Number(item);
  });
  return new Date(a[0], a[1] - 1, a[2], a[3], a[4], a[5]).getTime();
};
/**
 * 格式化时间戳为某种格式
 * @param timestamp 时间戳
 * @param  format    格式
 * @example format(1438931394268, 'YYYY-MM-DD hh:mm:ss') => '2015-08-07 15:09:54'
 */

var format = function format(timestamp) {
  var formatStr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD hh:mm:ss';
  var returnFormat = formatStr;

  if (isNaN(timestamp) || timestamp < 1) {
    return '';
  }

  var date = new Date(timestamp);
  var utc = date.getTimezoneOffset() / 60;
  date.setHours(date.getHours() + (utc + 8));
  var weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
  var obj = {
    'M+': date.getMonth() + 1,
    'D+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    S: date.getMilliseconds(),
    w: weeks[date.getDay()] // 星期

  };

  if (/(Y+)/.test(returnFormat)) {
    returnFormat = returnFormat.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }

  for (var k in obj) {
    if (new RegExp('(' + k + ')').test(returnFormat)) {
      returnFormat = returnFormat.replace(RegExp.$1, RegExp.$1.length === 1 ? obj[k] : ('00' + obj[k]).substr(('' + obj[k]).length));
    }
  }

  return returnFormat;
};
/**
 * 计算时间差
 * 1、时间差大于1天，精确到天，例如明天，后天，具体日期；
 * 2、时间差小于1天但大于1小时，输出天和时分秒；
 * 3、时间差小于1小时并大于1分钟，精确到分钟；
 * 4、时间差小于1分钟，用模糊词。
 * @param options.timestamp 时间戳
 * @param options.current   时间戳（不填默认本地当前时间）
 * @param options.format   大于2天显示什么时间格式（不填默认YYYY年MM月DD日）
 * @example difference({ timestamp: 1438931394268 }) => '3分钟'
 */

var difference = function difference(options) {
  var now = new Date().getTime();

  var _options = Object.assign({
    timestamp: now + 1000,
    current: now,
    format: 'YYYY年MM月DD日'
  }, options);

  var originalDate = new Date(_options.timestamp);
  var currentDate = new Date(_options.current);
  var interval = Math.abs(_options.current - _options.timestamp);
  var days = Math.floor(interval / 1000 / 60 / 60 / 24); // 相差天数

  var hours = Math.floor(interval / 1000 / 60 / 60 % 24); // 相差小时数

  var minutes = Math.floor(interval / 1000 / 60 % 60); // 相差分钟数

  var text = _options.current > _options.timestamp ? ['刚刚', '分钟前', '今天', '昨天', '前天'] : ['稍后', '分钟后', '今天', '明天', '后天'];
  var timeHtml;

  if (days) {
    switch (days) {
      case 1:
        timeHtml = text[4];
        break;

      default:
        timeHtml = format(_options.timestamp, _options.format);
    }
  } else if (hours) {
    var diffDays = Math.abs(originalDate.getDate() - currentDate.getDate()); // TODO: 如果跨月份，diffDays有可能相差大于1

    if (diffDays === 1 || diffDays > 2) {
      timeHtml = text[3];
    } else {
      timeHtml = text[2];
    }
  } else if (minutes) {
    timeHtml = minutes + text[1];
  } else {
    timeHtml = text[0];
  }

  return timeHtml;
};
/**
 * 倒计时格式化工具
 * @param options.timestamp: 节点时间戳
 * @param options.current: 当前时间戳
 * @param options.format: 格式化字符串
 * @param options.timeout: 倒计时完后的回调
 */

var countdown = function countdown(options) {
  var now = new Date().getTime();

  var _options = Object.assign({
    timestamp: now + 1000,
    current: now,
    format: 'D天h时m分s秒',
    timeout: function timeout() {}
  }, options);

  var interval = _options.timestamp - _options.current;
  var obj = {
    'D+': Math.floor(interval / 1000 / 60 / 60 / 24),
    'h+': Math.floor(interval / 1000 / 60 / 60 % 24),
    'm+': Math.floor(interval / 1000 / 60 % 60),
    's+': Math.floor(interval / 1000 % 60) // 相差秒数

  };
  var returnFormat = _options.format;

  if (interval < 0) {
    _options.timeout();

    return false;
  }

  for (var k in obj) {
    if (new RegExp('(' + k + ')').test(returnFormat)) {
      // 兼容多位数天数,例如3位，4位，5位...
      var substrLength = Math.min(RegExp.$1.length, ('' + obj[k]).length);
      returnFormat = returnFormat.replace(RegExp.$1, RegExp.$1.length === 1 ? obj[k] : ('00' + obj[k]).substr(substrLength));
    }
  }

  return returnFormat;
};

export { parse, format, difference, countdown };
